<div class="card mt-2 outbound-faxes">
  <div class="card-body">
    <div class="row">
      <div class="col-7"><h4 class="mb-2">Outbound Faxes</h4></div>
      @if (!loading && selectedOutboundFax && outboundFaxes.length > 0) {
        <div class="col-5 text-end">
          <a href="#/clear" class="btn btn-sm btn-danger" (click)="onClearClick($event)">Clear Selection</a>
        </div>
      }
    </div>
    @if (selectedPatient && selectedPrescriber) {
      @if (loading) {
        <div><mat-spinner diameter="30" /></div>
      } @else {
        @if (!loading && !selectedOutboundFax && outboundFaxes.length > 0) {
          <p class="mt-2 p-2 bg-light">
            Please attribute this inbound fax to one of the outbound faxes below. <small><i>(optional)</i></small>
          </p>
        }
        @if (!loading && outboundFaxes.length > 0) {
          <div class="mt-2 outbound-faxes">
            <table class="table table-sm  table-hover table-bordered">
              <thead>
                <tr>
                  <th class="text-nowrap">DATE FAXED &#x25BC;</th>
                  <th>PRESCRIBER</th>
                  <th>OFFICE</th>
                </tr>
              </thead>
              <tbody>
                @for (outboundFax of outboundFaxes; track outboundFax) {
                  <tr>
                    <td>
                      <div class="form-check">
                        <input
                          [id]="'outboundFax' + outboundFax.id"
                          name="selectedOutboundFaxId"
                          class="form-check-input"
                          type="radio"
                          [(ngModel)]="selectedOutboundFaxId"
                          (change)="onOutboundFaxChanges(outboundFax)"
                          [value]="outboundFax.id"
                          />
                        <label class="form-check-label ms-2" [id]="'outboundFax' + outboundFax.id">
                          {{ outboundFax.mostRecentAttemptAt | date: 'MM/dd/yyyy' }}
                          <div>
                            <small>
                              <strong>
                                <app-office-fax [office]="outboundFax.office" />
                              </strong>
                            </small>
                            @if (outboundFax.status === outboundFaxStatuses.failed) {
                              <div class="text-danger">Fax Failed</div>
                            }
                          </div>
                        </label>
                      </div>
                    </td>
                    <td>
                      <app-prescriber-name [provider]="outboundFax.provider" [linkToProvider]="true" />
                    </td>
                    <td>
                      {{
                      outboundFax.prescriberOfficesNames && outboundFax.prescriberOfficesNames.length > 0
                      ? outboundFax.prescriberOfficesNames.join(', ')
                      : null | blankValueDash
                      }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <p class="mt-2 p-2 bg-light">No outbound faxes found.</p>
        }
      }
    } @else {
        <p class="mt-2 p-2 bg-light">Please select a patient and prescriber.</p>
    }
  </div>
</div>
